import * as primitives from './primitives'
import * as forms from './forms'
import * as table from './table'
import * as icons from './icons'
import { BModal, modalService, toastService } from './modal'
export default {
  install(app) {
    for (const [name, component] of Object.entries({
      ...primitives,
      ...primitives.simpleComponents,
      ...forms,
      ...table,
      ...icons,
      BModal
    })) {
      if (name.startsWith('B')) app.component(name, component)
    }
    app.config.globalProperties.$bvModal = modalService
    app.config.globalProperties.$bvToast = toastService
  }
}
